import { render, staticRenderFns } from "./ArticleEditor.vue?vue&type=template&id=0f0b9308&"
import script from "./ArticleEditor.vue?vue&type=script&lang=ts&"
export * from "./ArticleEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports